export const legacyAppProps = {
  basename: "/plataforma",
};
